import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './routes'; // Assuming this is your main route file
import './App.css';
import OptinMonsterScript from './OptinMonsterScript'; // Import the OptinMonster script component
import ResumeHandler, { hasResumeToken } from './components/ResumeHandler';

function App() {
    if (hasResumeToken()) {
        return <ResumeHandler />;
    }
    return (
        <BrowserRouter>
            <OptinMonsterScript /> {/* Add OptinMonster Script */}
            <Router />
        </BrowserRouter>
    );
}

export default App;
